import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  groupTitle: {
    defaultValue: 'Agrupar nichos',
    key: 'EditNicheModal-groupTitle',
  },
  renameTitle: {
    defaultValue: 'Renomear nichos',
    key: 'EditNicheModal-renameTitle',
  },
})
